import { WGisDisplayMode, WGisToolOption, WGisToolContainerOption, WGisAlignement, WGisToolInterface } from './wgis.utils';


export enum ToolsNames {
  CLOSE = 'close',
  MEASUREDISTANCE = 'measureDistance',
  MEASUREAREA = 'measureArea ',
  INFO = 'info',
  MAP_LEGEND = 'mapLegend',
  RESETINTERACTION = 'resetInteraction',
  CLEARSELECTION = 'clearSelection',
  FINDME = 'findMe',
  DRAWPOINT = 'drawPoint',
  DRAWPOLYGON = 'drawPolygon',
  DRAWLINE = 'drawLine',
  MODIFY = 'modify',
  FOLLOWME = 'followMe'
}



export class WGisBaseTool implements WGisToolInterface {
  private element: HTMLElement;
  private target: HTMLElement;


  constructor(protected opt: WGisToolOption) {
    this.element = document.createElement('button');
    const classes = 'wgis-tool fa ' + this.opt.icon;
    this.element.className = classes;
    this.element.onclick = () => { this.trigger(); };
    if (this.opt.title) {
      this.element.title = this.opt.title;
    }
  }
  /**
   * overide se il toolnon ha ui icona o altro
   */
  hasUi(): boolean { return true; }

  getElement(): HTMLElement {
    return this.element;
  }

  isActive(): boolean {
    return this.opt.active;
  }

  activate(): void {
    this.opt.active = true;
  }

  deactivate(): void {
    this.opt.active = true;
  }

  show(): void {
    // this.element.style.setProperty('visibility', 'visible');
    this.element.style.removeProperty('display');
  }

  hide(): void {
    // this.element.style.setProperty('visibility', 'hidden');
    this.element.style.setProperty('display', 'none');
  }

  trigger(): void {
    if (this.opt.trigger) {
      this.opt.trigger.apply(this);
    }
  }
}
export class WGisToolContainer {
  // protected opt: WGisToolContainerOption;
  private element: HTMLElement;
  private target: HTMLElement;
  private tools: WGisToolInterface[];
  pTarget: Promise<HTMLElement>;
  constructor(protected opt: WGisToolContainerOption) {

    // this.opt = options;
    this.element = document.createElement('div');

    // let classes = 'ol-unselectable ol-control wgis-tool-container';
    let classes = 'ol-unselectable wgis-tool-container';
    switch (this.opt.alignment) {
      case WGisAlignement.horizontalTopLeft: {
        classes = 'ol-unselectable wgis-tool-container wgis-horizontal wgis-top wgis-left';
        break;
      }
      case WGisAlignement.horizontalBottomLeft: {
        classes = 'ol-unselectable wgis-tool-container wgis-horizontal wgis-bottom wgis-left';
        break;
      }
      case WGisAlignement.horizontalMidLeft: {
        classes = 'ol-unselectable wgis-tool-container wgis-horizontal wgis-mid wgis-left';
        break;
      }
      case WGisAlignement.horizontalTopRight: {
        classes = 'ol-unselectable wgis-tool-container wgis-horizontal wgis-top wgis-right';
        break;
      }
      case WGisAlignement.horizontalMidRight: {
        classes = 'ol-unselectable wgis-tool-container wgis-horizontal wgis-mid wgis-right';
        break;
      }
      case WGisAlignement.horizontalBottomRight: {
        classes = 'ol-unselectable wgis-tool-container wgis-horizontal wgis-bottom wgis-right';
        break;
      }
      case WGisAlignement.verticalTopLeft: {
        classes = 'ol-unselectable wgis-tool-container wgis-vertical wgis-top wgis-Left';
        break;
      }
      case WGisAlignement.verticalBottomLeft: {
        classes = 'ol-unselectable wgis-tool-container wgis-vertical wgis-bottom wgis-Left';
        break;
      }
      case WGisAlignement.verticalMidLeft: {
        classes = 'ol-unselectable wgis-tool-container wgis-vertical wgis-mid wgis-Left';
        break;
      }
      case WGisAlignement.verticalTopRight: {
        classes = 'ol-unselectable wgis-tool-container wgis-vertical wgis-top wgis-right';
        break;
      }
      case WGisAlignement.verticalMidRight: {
        classes = 'ol-unselectable wgis-tool-container wgis-vertical wgis-mid wgis-right';
        break;
      }
      case WGisAlignement.VerticalBottomRight: {
        classes = 'ol-unselectable wgis-tool-container wgis-vertical wgis-bottom wgis-right';
        break;
      }
      default: {
        classes = 'ol-unselectable wgis-tool-container wgis-horizontal wgis-top wgis-left';
        break;
      }
    }

    this.element.className = classes;
    this.tools = [];
    this.pTarget = new Promise<HTMLElement>((resolve, reject) => {
      this.opt.wgisservice.pMap.then((map) => {
        this.target = map.getOverlayContainerStopEvent();
        this.target.appendChild(this.element);
        resolve(this.target);
      }).catch((reason) => {
        reject(reason);
      });
    });
  }

  addTool(tool: WGisToolInterface) {
    this.tools.push(tool);
    if (tool.hasUi()) {
      this.element.appendChild(tool.getElement());
      this.opt.wgisservice.pMap.then((map) => { map.render(); });
    }
  }

}


